<div class="position-relative">
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
  <h1 mat-dialog-title><strong>Resultado del proceso de resumen</strong></h1>
  <div class="table-container">


    <mat-card *appRole="['Contratos.GenerarResumenMasivoDetalle']" [hidden]=!verTabla>
      <ngx-spinner [zIndex]="100" name="spresultadoEnvioMasivo" bdColor="rgba(255,255,255,0.8)" size="default"
        color="#009688" type="ball-atom" [fullScreen]="false">
      </ngx-spinner>

      <mat-card class="p-4">
        <mat-card-title>Resumen del Proceso de Envío</mat-card-title>
        <mat-card-content>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

            <div><strong>ID Proceso Masivo:</strong> {{ data.idProcesoMasivo }}</div>
            <div><strong>Duración Total:</strong> {{ (data.duracionTotal / 60000) | number: '1.0-2' }} minutos</div>

            <div><strong>Fecha de Inicio:</strong> {{ data.fechaInicio | date: 'short' }}</div>
            <div><strong>Fecha de Fin:</strong> {{ data.fechaFin | date: 'short' }}</div>

            <div><strong>Total Procesados:</strong> {{ data.totalProcesados }}</div>
            <div><strong>Total Errores:</strong>
              <span style="color: red">{{ data.totalErrores }}</span> / {{ data.totalProcesados }}
            </div>

            <div><strong>Total Exitosos:</strong>
              <span style="color: green">{{ data.totalExitosos }}</span> / {{ data.totalProcesados }}
            </div>
            <div><strong>Resumen Generado OK:</strong>
              <span style="color: green">{{ data.totalGeneracionResumenExitosos }}</span> / {{ data.totalProcesados }}
            </div>

            <div><strong>Resumen No Generados:</strong>
              <span style="color: red">{{ data.totalGeneracionResumenErrores }}</span> / {{ data.totalProcesados }}
            </div>
            <div><strong>Archivo Generado OK:</strong>
              <span style="color: green">{{ data.totalGeneracionArchivoExitosos }}</span> / {{ data.totalProcesados }}
            </div>

            <div><strong>Archivo No Generados:</strong>
              <span style="color: red">{{ data.totalGeneracionArchivoErrores }}</span> / {{ data.totalProcesados }}
            </div>
          </div>


          <mat-divider class="my-4"></mat-divider>

          <h3 class="text-lg font-medium mb-2">Detalle de Resultados</h3>


          <table mat-table [dataSource]="dataSource" matSort [hidden]=!verTabla class="mat-elevation-z8">

            <!-- Numero de Contrato -->
            <ng-container matColumnDef="numeroContrato">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Numero contrato</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <a [routerLink]="['/contratos',element.idContrato]"
                  class="contrato-link">{{element.numeroContrato}}</a>

              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="generacionResumenExitosa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Resumen</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.generacionResumenExitosa" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.generacionResumenExitosa" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="generacionArchivoExitosa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Archivo</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.generacionArchivoExitosa" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.generacionArchivoExitosa" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="envioExitoso">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Envio correo</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.envioExitoso" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.envioExitoso" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <!-- Estado Envio Exitoso (Icono) -->
            <ng-container matColumnDef="emailValido">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Correo valido</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.emailValido" color="primary">check_circle</mat-icon>
                <mat-icon *ngIf="!element.emailValido" color="warn">cancel</mat-icon>
              </td>
            </ng-container>

            <ng-container matColumnDef="emailDestino">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Correo destino</span>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.emailDestino | titlecase}}
              </td>
            </ng-container>

            <ng-container matColumnDef="tiempoDuracionEnvio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Duración/ms </span>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.tiempoDuracionEnvio}}
              </td>
            </ng-container>


            <ng-container matColumnDef="metodoEnvio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Metodo envio</span>
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.metodoEnvio | titlecase}}
              </td>
            </ng-container>

            <!-- Fecha Envio -->
            <ng-container matColumnDef="fechaEnvio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <span>Fecha envio</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <span>{{element.fechaEnvio | date:'yyyy-MM-dd HH:mm:ss'}}</span>
              </td>
            </ng-container>

            <!-- Mensaje con opción de expandir -->
            <ng-container matColumnDef="mensaje">
              <th mat-header-cell *matHeaderCellDef>
                <span>Mensaje</span>
              </th>
              <td mat-cell *matCellDef="let element">
                <span [matTooltip]="element.mensaje">{{element.mensaje | slice:0:100}}...</span>
                <button mat-icon-button (click)="openMessageDialog(element.mensajeDetalle)">
                  <mat-icon>expand_more</mat-icon>
                </button>
              </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator showFirstLastButtons class="paginator" [hidden]=!verTabla [pageSize]="20"
            [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
          </mat-paginator>
        </mat-card-content>
      </mat-card>
    </mat-card>



    <app-sin-datos *ngIf="dataSource.data.length == 0 || dataSource.data == undefined"></app-sin-datos>
  </div>


</div>
